export const getLoadMoreLimit = (
  currentLength: number,
  messageTake: number,
  totalTake?: number,
) => {
  if (totalTake) {
    if (currentLength + messageTake > totalTake) {
      return totalTake;
    }
  }
  return currentLength + messageTake;
};
